import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/vuex-test',
            name: 'admin-vuex-test',
            component: () => import(/* webpackChunkName: "page-admin-default-vuex-test" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "vuex-test"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "vuex-test"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
